import { render } from "./DashboardAlertsPerZone.vue?vue&type=template&id=ec0ca728&scoped=true"
import script from "./DashboardAlertsPerZone.vue?vue&type=script&lang=js"
export * from "./DashboardAlertsPerZone.vue?vue&type=script&lang=js"

import "./DashboardAlertsPerZone.vue?vue&type=style&index=0&id=ec0ca728&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0ca728"]])

export default __exports__